import { useNotifications } from '../context/NotificationContext';

/**
 * A number that changes whenever the page's data may have gone stale.
 *
 * Put it in a fetch effect's dependency array and the page reloads itself —
 * when a notification arrives, when the socket reconnects after a sleep or a
 * dropped connection, and when the user comes back to the tab.
 *
 *   const revision = useLiveRefresh();
 *
 *   useEffect(() => {
 *     apiClient.get('/api/tasks/my-tasks').then(...);
 *   }, [revision]);
 *
 * ⚠️ DO NOT PUT IT ON A FORM, A DETAIL PAGE BEING EDITED, OR ANYTHING WITH
 * UNSAVED INPUT. This refetches without asking, and overwriting half-typed work
 * because a colleague was assigned an unrelated task is far worse than showing
 * a list that is thirty seconds old. Lists, dashboards and queues — the screens
 * people leave open and glance at — are what this is for.
 *
 * ⚠️ IT SAYS "RE-ASK", NOT WHAT CHANGED. Deliberately: a signal carrying the
 * changed rows would need every page to merge them by hand, and would show
 * state the server never confirmed. Refetching is one request and always right.
 */
export function useLiveRefresh() {
  return useNotifications().revision;
}

/**
 * Force a refresh from an action the socket cannot see — the escape hatch for
 * "I just saved this, and the list two components away should notice".
 */
export function useRefreshNow() {
  return useNotifications().bumpRevision;
}

export default useLiveRefresh;
